import { Button, Modal } from '@themesberg/react-bootstrap';

import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { studentDataUpdateSaga } from 'reduxToolkit/actions';
import { studentReducerTypes } from 'types';
import { isValidPhone } from 'utils/helpers';

export const StudentModal = ({
    handleClose,
    studentEditData,
}: {
    handleClose: any;
    studentEditData?: studentReducerTypes.IStudent | null;
}) => {
    const dispatch = useDispatch();

    const [registerType] = useState('newUser');
    const [event_id] = useState(null);
    const [name, setName] = useState(studentEditData?.name || '');
    const [email, setEmail] = useState(studentEditData?.email || '');
    const [mobileNumber, setMobileNumber] = useState(studentEditData?.mobileNumber || '');
    const [collegeName, setCollegeName] = useState(studentEditData?.collegeName || '');
    const [department, setDepartment] = useState(studentEditData?.department || '');
    const [whichYear, setWhichYear] = useState(studentEditData?.whichYear || '');
    const [nationality, setNationality] = useState(studentEditData?.nationality || '');
    const [state, setState] = useState(studentEditData?.state || '');
    const [city, setCity] = useState(studentEditData?.city || '');

    const [errorMsg, setErrorMsg] = useState('');

    const dispatchCustomer = useCallback(() => {
        if (
            name === '' ||
            email === '' ||
            mobileNumber === '' ||
            collegeName === '' ||
            department === '' ||
            whichYear === '' ||
            nationality === '' ||
            state === '' ||
            city === ''
        ) {
            setErrorMsg('Some fields are missing');
            return;
        }

        const mobileCheck = isValidPhone(mobileNumber);
        if (!mobileCheck) {
            setErrorMsg('Enter valid mobile number');
            return;
        }
        setErrorMsg('');
        const data = {
            id: studentEditData?.id || null,
            name,
            email,
            mobileNumber,
            collegeName,
            department,
            whichYear,
            nationality,
            state,
            city,
            registerType,
            event_id,
        };
        dispatch(studentDataUpdateSaga(data));
    }, [
        dispatch,
        studentEditData,
        name,
        email,
        mobileNumber,
        collegeName,
        department,
        whichYear,
        nationality,
        state,
        city,
        registerType,
        event_id,
    ]);
    return (
        <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Student</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMsg && (
                    <div className="alert alert-danger" role="alert">
                        {errorMsg}
                    </div>
                )}
                <div className="col-12">
                    <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        placeholder="Name"
                        className="form-control"
                    />
                </div>
                <div className="col-12 mt-2">
                    <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="text"
                        placeholder="Email"
                        className="form-control"
                    />
                </div>
                <div className="col-12 mt-2">
                    <input
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        type="text"
                        placeholder="Mobile Number"
                        className="form-control"
                    />
                </div>
                <div className="col-12 mt-2">
                    <input
                        value={collegeName}
                        onChange={(e) => setCollegeName(e.target.value)}
                        type="text"
                        placeholder="College Name"
                        className="form-control"
                    />
                </div>
                <div className="col-12 mt-2">
                    <div className="row">
                        <div className="col-lg-6 col-12 mt-2">
                            <input
                                value={department}
                                onChange={(e) => setDepartment(e.target.value)}
                                type="text"
                                placeholder="Department"
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-6 col-12  mt-2">
                            <input
                                value={whichYear}
                                onChange={(e) => setWhichYear(e.target.value)}
                                type="text"
                                placeholder="Which Year"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-2">
                    <div className="row">
                        <div className="col-lg-4 col-12 mt-2">
                            <input
                                value={nationality}
                                onChange={(e) => setNationality(e.target.value)}
                                type="text"
                                placeholder="Nationality"
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-4 col-12  mt-2">
                            <input
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                type="text"
                                placeholder="State"
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-4 col-12  mt-2">
                            <input
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                placeholder="City"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button onClick={() => dispatchCustomer()} variant="primary">
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
